import history from '../config/routerPageStackHistory'
import config from '../config/routerPageStackConfig'
const stack = []

export const getIndexByKey = key => {
  for (let index = 0; index < stack.length; index++) {
    if (stack[index].routeName === key.name) {
      return index
    }
  }
  return -1
}
export const VuePageStack = (to) => {
  // const slot = this.$slots.default;
  // const vnode = getFirstComponentChild(slot);
  // if (!vnode) {
  //   return vnode;
  // }
  const index = getIndexByKey(to)
  // console.log(to.name, 888888888)
  if (index !== -1) {
    for (let i = index + 1; i < stack.length; i++) {
      stack[i] = null
    }
    stack.splice(index + 1)
  } else {
    if (history.action === config.replaceName) {
      stack[stack.length - 1] = null
      stack.splice(stack.length - 1)
    }
    // console.log(history.action, config.replaceName)
    if (stack.length > 2 && stack[stack.length - 1].routeName === to.name) {
      // eslint-disable-next-line semi
      return
    }
    stack.push({
      // eslint-disable-next-line no-undef
      routeName: to.name,
      // eslint-disable-next-line no-undef
      path: to.path
    })
  }
  // console.log(stack, '这个是路由栈哦~RRRRRRRRR', to)
}
export const getStack = () => {
  return stack
}
